import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id D7A8DF8D-096F-420D-B14C-5F523A5171CF
 * name triangle-down
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triangle-down.svg
 * tags
 * - Shape 
 */
export const TriangleDownIcon = createSvgIcon(<><path d="M1 3H23L12 22" /></>, 'TriangleDownIcon');
export default TriangleDownIcon